import _ from 'lodash'
import { RootState } from '../../types/RootState'

class PlanningRecordSelectors {
  getPlanningRecord = _.memoize(
    ({ planningRecordId }: { planningRecordId: string }) =>
      (state: RootState) =>
        state.planningRecord.planningRecord?.id === planningRecordId
          ? state.planningRecord.planningRecord
          : undefined,
    ({ planningRecordId }) => planningRecordId,
  )
  getLoading = _.memoize(
    ({ loadingWhenInitial }: { loadingWhenInitial: boolean } = { loadingWhenInitial: true }) =>
      (state: RootState) =>
        loadingWhenInitial
          ? state.planningRecord.status === 'initial' || state.planningRecord.status === 'loading'
          : state.planningRecord.status === 'loading',
    props => !!props?.loadingWhenInitial,
  )
  getInitial = (state: RootState) => state.planningRecord.status === 'initial'
  getHasError = (state: RootState) => state.planningRecord.status === 'failed'
  getError = (state: RootState) => state.planningRecord.error
}

export default new PlanningRecordSelectors()
